import { forwardRef, useEffect, useState } from "react";
import { Dropdown, DropdownProps, Grid } from "semantic-ui-react";

import { InputNumber } from "../InputText/InputNumber";

import { isEmpty } from "lodash";
import "./inputWithDropDown.scss";

interface Option {
  key: string | number;
  value: string | number;
  text: string;
}

interface InputWithDropDownProps {
  defaultSelectValue: string | number;
  options: Option[];
  selectOption?: (value: string | number) => void;
  [key: string]: any; // for passing extra props to InputNumber
}

interface HandleValidation {
  checkCustomRequired(data?: any): void;
}

const InputWithDropDown = forwardRef<HandleValidation, InputWithDropDownProps>(
  (
    {
      defaultSelectValue,
      options = [],
      selectOption = () => {},
      disableDropDown = false,
      upward = false,
      ...restProps
    },
    ref
  ) => {
    const [selected, setSelected] = useState<string | number>(defaultSelectValue);
    const isLableAvailble = isEmpty(restProps.labelName);

    useEffect(() => {
      setSelected(defaultSelectValue);
    }, [defaultSelectValue, options]);

    return (
      <Grid>
        <Grid.Column>
          <InputNumber {...restProps} ref={ref} />
          <div
            className={
              isLableAvailble ? "inputWithDropDownSelect" : "inputTitleWithoutDropDownSelect"
            }
          >
            <Dropdown
              value={selected}
              options={options}
              upward={upward}
              onChange={(_, data: DropdownProps) => {
                setSelected(data.value as string | number);
                selectOption(data.value as string | number);
              }}
              disabled={disableDropDown}
            />
          </div>
        </Grid.Column>
      </Grid>
    );
  }
);

export default InputWithDropDown;
